import AssocAsssetsWidget from './AssocAssetsWidget';

export default {
  'views.components.assetInformationActions': [{ component: AssocAsssetsWidget, key: 'assets' }],
};
